import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_489: DocMigration = {
  maxSchemaVersion: "0.0.489",
  description: "Empty foundationSystem and foundation tables",
  apply(json: any): any {
    // Empty foundationSystems table
    json.foundationSystems = {};

    // Empty foundations table
    json.foundations = {};

    return json;
  },
};

export default migration_0_0_489;
